export const KEY_COUNTRY_INDICATOR_VES = 'keyCountryIndicator';

export const KEY_COUNTRY_INDICATOR_VES_ACTIONS_NAME = {
  getIndicators: `${KEY_COUNTRY_INDICATOR_VES}/getIndicators`,
  getCountriesList: `${KEY_COUNTRY_INDICATOR_VES}/getCountriesList`,
};

export const KEY_COUNTRY_INDICATOR_VES_MUTATIONS_NAME = {
  setIndicators: `${KEY_COUNTRY_INDICATOR_VES}/setIndicators`,
  setCountriesList: `${KEY_COUNTRY_INDICATOR_VES}/setCountriesList`,
};

export const KEY_COUNTRY_INDICATOR_VES_GETTERS_NAME = {
  getIndicators: `${KEY_COUNTRY_INDICATOR_VES}/getIndicators`,
  getCountriesList: `${KEY_COUNTRY_INDICATOR_VES}/getCountriesList`,
};
